<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <form @submit.prevent="onSubmit()">
            <div class="card-body">
                <p>
                    Select which roles to grant to this application. The change in roles will be applied the next time
                    the person's session is refreshed.
                </p>

                <ul style="list-style: none">
                    <li :key="role.id" v-for="role in availableRoles">
                        <div class="custom-control custom-checkbox">
                            <input :id="role.id" :value="role.id" class="custom-control-input" type="checkbox"
                                   v-model="personRoles"/>
                            <label :for="role.id" class="custom-control-label">
                                {{role.name}}
                            </label>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="card-footer d-print-none text-right">
                <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                <RouterLink :to="{name:'People'}" class="btn btn-danger">Back</RouterLink>
            </div>
        </form>
    </AppLoadingContainer>
</template>

<script>
    import PersonService from "@/services/PersonService";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import {ToastType} from "@/services/models/shared/ToastType";

    export default {
        components: {
            AppLoadingContainer
        },
        data() {
            return {
                personRoles: [],
                availableRoles: [],
                isLoaded: false,
                isSubmitting: false,
            }
        },
        props: {
            personId: {
                type: String,
                required: true
            }
        },
        methods: {
            onSubmit() {
                const vm = this;

                this.isSubmitting = true;
                PersonService.updateRolesForPerson(vm.personId, vm.personRoles)
                    .then(() => {
                        vm.alert(ToastType.Success, "The person roles were successfully updated")
                    }).catch(error => {
                    vm.alert(ToastType.Danger, error.response.statusText)
                }).finally(() => {
                    vm.isSubmitting = false
                });
            }
        },
        created() {
            const vm = this;

            Promise.all([
                PersonService.getAllRoles({
                    includeUnassignableRoles: false,
                    onlyDelegatableRoles: false
                })
                    .then(response => vm.availableRoles = response),

                PersonService.getRolesForPerson(vm.personId, {
                    includeUnassignableRoles: false,
                    onlyDelegatableRoles: false
                })
                    .then(response => vm.personRoles = response.map(item => item.id))]).catch(() => {
                vm.redirectToError();
            }).finally(() => {
                vm.isLoaded = true;
            });
        }
    }
</script>
